/**
 * @file FormEditPassport
 */
'use strict';

/**
 * @classname FormEditPassport
 * @classdesc 登録
 */
export default class FormEditPassport {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 */
	constructor(controller){
		this._controller = controller;
	};


	/**
	 * フォーム送信前処理
	 *
	 * @memberof FormRegistration
	 * @return {undefined}
	 */
	preProcessing($form) {
		console.log('FormEditPassport.preProcessing');
		// バリデーション後に行う処理を記載（開始）


		// バリデーション後に行う処理を記載（終了）
		this._controller.completePreProcessing($form);
	};


	/**
	 * フォーム送信後処理
	 *
	 * @memberof FormEditPassport
	 * @return {undefined}
	 */
	postProcessing($form) {
		console.log('FormEditPassport.postProcessing');
		// バリデーション後に行う処理を記載（開始）

		const childName = $('#child_name_edit').val();
		const cityCode = $('#city_code_edit').val();
		const cityName = $('#city_code_edit option:selected').text();
		const childBirthdayYY = $('#child_birthday_yy_edit').val();
		const childBirthdayMM = $('#child_birthday_mm_edit').val();
		const childBirthdayDD = $('#child_birthday_dd_edit').val();

		if (!cityCode) {
			return;
		}

		var passportList = [];
		passportList.push({
			child_name: childName,
			city_code: cityCode,
			city_name: cityName,
			child_birthday_yy: childBirthdayYY,
			child_birthday_mm: childBirthdayMM,
			child_birthday_dd: childBirthdayDD
		});

		// 子供追加対応
		for (var _i=2; _i<6; _i++) {
			if ($('#child_name_edit_' + _i).length) {
				const _childName = $('#child_name_edit_' + _i).val();
				// const _cityCode = $('#city_code_edit_' + _i).val();
				// const _cityName = $('#city_code_edit_' + _i + ' option:selected').text();
				const _childBirthDayYY = $('#child_birthday_yy_edit_' + _i).val();
				const _childBirthDayMM = $('#child_birthday_mm_edit_' + _i).val();
				const _childBirthDayDD = $('#child_birthday_dd_edit_' + _i).val();

				passportList.push({
					child_name: _childName,
					city_code: cityCode,
					city_name: cityName,
					child_birthday_yy: _childBirthDayYY,
					child_birthday_mm: _childBirthDayMM,
					child_birthday_dd: _childBirthDayDD
				});
			} else {
				// 以降追加なし
				break;
			}
		}

		//this._controller.setPassportInfo($form, childName, cityCode, cityName, childBirthdayYY, childBirthdayMM, childBirthdayDD);
		this._controller.setPassportInfos($form, passportList);
		this._controller._$passportEditModal.hide();
		this._controller.initialize();
	};
}
